export type EstrategiaItemModel = {
    status: boolean
    descricao: string
}

export type EstrategiasFornecedorModel = {
    pontuacao: number
    freteGratis: EstrategiaItemModel
    cupomAutomatico: EstrategiaItemModel
    selosPremiados: EstrategiaItemModel
    notificacoes: EstrategiaItemModel
    fidelidade: EstrategiaItemModel
    promocaoDoDia: EstrategiaItemModel
    formaDePagamento: EstrategiaItemModel
    pedidosMesa: boolean
}

const estrategiaItemVazio: EstrategiaItemModel = { status: false, descricao: "" }

export const EstrategiasFornecedorInicial: EstrategiasFornecedorModel = {
    pontuacao: 0,
    freteGratis: estrategiaItemVazio,
    cupomAutomatico: estrategiaItemVazio,
    selosPremiados: estrategiaItemVazio,
    notificacoes: estrategiaItemVazio,
    fidelidade: estrategiaItemVazio,
    promocaoDoDia: estrategiaItemVazio,
    formaDePagamento: estrategiaItemVazio,
    pedidosMesa: false,
}
